import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Popper from "@material-ui/core/Popper";
import List from "@material-ui/core/List";
import ReactDOMServer from "react-dom/server";
import Chip from "@material-ui/core/Chip";
import { replaceLastOccurrenceInString } from "../../utils";

class Suggestions extends React.Component {
  constructor(props) {
    super(props);
  }


  addSuggestionIntoParent = (suggestion, suggestionType) => {
    this.props.parent.innerHTML = replaceLastOccurrenceInString(
      this.props.parent.innerHTML,
      this.props.suggestionsSource,
      ReactDOMServer.renderToStaticMarkup(this.props.getSuggestionChip(suggestion, suggestionType))
    );
  };

  /**
   * Convert a HTML string like "one <b>t</b>wo three" to a proper React component.
   * NB This function exists because rendering HTML from a string is possible but *not* recommended:
   * https://stackoverflow.com/a/19277723/6696049
   */
  renderHighlightedSuggestionItem = highlight => {
    if (!highlight) {
      return "";
    }

    const highlightOpeningTag = "<b>";
    const highlightClosingTag = "</b>";

    const partsForSplitOnOpeningTag = highlight.split(highlightOpeningTag);

    if (partsForSplitOnOpeningTag.length < 2) {
      return highlight;
    }

    const remainingElementsOfOpeningTag = partsForSplitOnOpeningTag.slice(1).join(highlightOpeningTag);
    const partsForSplitOnClosingTag = remainingElementsOfOpeningTag.split(highlightClosingTag);

    if (partsForSplitOnClosingTag.length < 2) {
      return highlight;
    }

    const remainingElementsOfClosingTag = partsForSplitOnClosingTag.slice(1).join(highlightClosingTag);

    return (
      <React.Fragment>
        {partsForSplitOnOpeningTag[0]}
        <b>{partsForSplitOnClosingTag[0]}</b>
        {this.renderHighlightedSuggestionItem(remainingElementsOfClosingTag)}
      </React.Fragment>
    );
  };

  getContentOfItemInSuggestionList = (highlight, plainSuggestion, suggestionType) => {
    let finalPlainSuggestion = plainSuggestion;
    let finalHighlight = highlight;

    if (suggestionType && suggestionType !== "") {
      finalPlainSuggestion = `${finalPlainSuggestion} (${suggestionType})`;
      finalHighlight = `${finalHighlight} (${suggestionType})`;
    }

    if (!highlight || highlight === "") {
      return finalPlainSuggestion;
    }

    const highlightedSuggestion = this.renderHighlightedSuggestionItem(finalHighlight);

    if (!highlightedSuggestion || highlightedSuggestion === "") {
      return finalPlainSuggestion;
    }

    return highlightedSuggestion;
  };

  render() {
    const suggestionItems = this.props.suggestions
      .filter(suggestion => suggestion && suggestion.name)
      .map((suggestion, i) => (
        /*
         * NB onMouseDown is used to solve the issue of onClick firing AFTER the onBlur event of the chatbot input div.
         * More info: https://stackoverflow.com/a/57630197/6696049
         */
        <ListItem
          button
          selected={i===this.props.activeIndex&&true}
          key={i}
          onClick={() => {
            this.addSuggestionIntoParent(suggestion.name, suggestion.type);
            this.props.resetParentSuggestionsState();
            this.props.disableSuggestionsMode();
            this.props.moveCursorToEndInParent();
          }}
          onMouseDown={e => {
            e.preventDefault();
          }}
        >
          <ListItemText
            primary={this.getContentOfItemInSuggestionList(suggestion.highlight.name, suggestion.name, suggestion.type)}
          />
        </ListItem>
      ));

    return (
      <Popper 
        open={this.props.shown}
        anchorEl={this.props.anchorEl}
        placement="bottom-start"
        disablePortal={false}
        modifiers={{
          flip: {
            enabled: true
          }
        }}
        id="suggestions-popper"
        style={{ zIndex: 9999, backgroundColor: "white" }} // todo use theme background color
      >
        <List>{suggestionItems}</List>
      </Popper>
    );
  }
}

export default Suggestions;
